import React from 'react';
import { GuestWeddingQuestionResponseQuery } from '../../generated/graphql';
import TextAnswerResponseCard from './TextAnswerResponseCard';
import OptionDataResponseCard from './OptionDataResponseCard';
import RsvpNotesCard from './RsvpNotesCard';
import styles from './rsvpSummaryCard.scss';
import { Body1 } from '@xo-union/tk-ui-typography';
import { Divider } from '../SettingsRail/Divider';

interface Props {
  guestWeddingQuestionData: GuestWeddingQuestionResponseQuery | undefined;
  dataColors: string[];
}

const GeneralQuestionCards: React.FC<Props> = ({ guestWeddingQuestionData, dataColors }) => {
  return (
    <>
      <Divider additionalStyles={styles.fullWidth} />
      <Body1 bold className={styles.generalQuestionSubhead} as="h3">
        General Questions
      </Body1>
      {guestWeddingQuestionData?.guestWeddingQuestionResponseData.questionsData?.map((question, index) => {
        if (question?.type === 'RSVPNote' && question?.answersData?.length) {
          return (
            <div className={styles.questionContainer} key={index}>
              <RsvpNotesCard question={question} />
            </div>
          );
        } else if (question?.answerType === 'Text') {
          return (
            <div className={styles.questionContainer} key={index}>
              <TextAnswerResponseCard question={question} />
            </div>
          );
        } else if (question?.answerType === 'Option') {
          return (
            <div className={styles.questionContainer} key={index}>
              <OptionDataResponseCard key={question.questionId} data={question} colors={dataColors} />
            </div>
          );
        }
      })}
    </>
  );
};

export default GeneralQuestionCards;
